import { Avtale } from '../interfaces';

export const getAvtaleFromId = (avtaleId: string, avtaler: Avtale[]): Avtale | undefined => {
  return avtaler.find((e: Avtale) => e.avtaleId === avtaleId);
};
